import React, { useContext } from 'react';

import CardPreview from '../../components/Previews/CardPreview';
import PhotoPreview from '../../components/Previews/PhotoPreview';
import OrderSummary from '../../components/Previews/OrderSummary';

import { PaneContext } from '../../contexts/PaneContext';
import { OrderContext } from '../../contexts/OrderContext';

const Preview = () => {
  const { orders } = useContext(OrderContext);
  const { activeTab } = useContext(PaneContext);
  return (orders.length > 0 && activeTab === 0) ||
    (orders.length > 0 && activeTab === 2) ? (
    <OrderSummary />
  ) : activeTab === 1 ? (
    <PhotoPreview />
  ) : (
    <CardPreview />
  );
};

export default Preview;
